import {
  ExecutionContext,
  RequestInterceptor,
  RequestInterceptorType,
  TapResponseFrame,
} from '@iotize/tap/client/api';
import { Observable } from 'rxjs';

export class InterceptorChain {
  interceptors: RequestInterceptor[];

  constructor(
    private target: (context: ExecutionContext) => Observable<TapResponseFrame>,
  ) {
    this.interceptors = [];
  }

  addInterceptor(interceptor: RequestInterceptorType) {
    this.interceptors.push(
      typeof interceptor === 'function'
        ? {
            intercept: interceptor,
          }
        : interceptor,
    );
    return this;
  }

  execute<T>(context: ExecutionContext): Observable<TapResponseFrame> {
    const runner = {
      index: 0,
      run: (context: ExecutionContext): Observable<TapResponseFrame> => {
        if (runner.index < this.interceptors.length) {
          runner.index++;
          return this.interceptors[runner.index - 1].intercept(context, {
            handle: (context) => {
              return runner.run(context);
            },
          });
        } else {
          return this.target(context);
        }
      },
    };
    return runner.run(context);
  }
}
